import {
	AfterViewInit,
	ComponentFactoryResolver,
	Directive,
	ElementRef,
	EventEmitter,
	Input, OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewContainerRef
} from "@angular/core";
import {HotKeysService} from "../services/hotkeys.service";
import {IHotKeyEvent} from "../interfaces/Ihotkey.event";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {IHotKey} from "../interfaces/Ihotkey";
import {HotKeyUtils} from "../services/hotkey.utils";
import {TitleTooltipDirective} from "../../ui/directives/title.tooltip/title.tooltip.directive";
import {Subscription} from "rxjs";
import {AuthLevel, UserPermissionsService} from "../../../app.services/permissions";

@UntilDestroy()
@Directive({
	selector: '[cpHotkeys]',
})
export class HotKeysDirective extends  TitleTooltipDirective implements  OnInit, AfterViewInit, OnDestroy, OnChanges  {
	@Input() codes: string | string[];
	@Input() disabled: boolean;
	@Input() permission: string;
	@Input() preventHotKeyEventDefault: boolean = true;
	@Input() subscribeToHotKeyEvent: boolean = true;
	@Input() disableTooltip: boolean = false;

	@Output() hotKeysPress: EventEmitter<IHotKeyEvent> = new EventEmitter<IHotKeyEvent>();

	private hotKeysPressSubscription: Subscription;
	private hotKeysSubscription: Subscription;

	private origTitleText:string;

	constructor(protected el: ElementRef,
				protected target:ViewContainerRef,
				protected componentFactoryResolver: ComponentFactoryResolver,
				private hotKeysService: HotKeysService,
				private hotKeyUtils: HotKeyUtils,
				private userPermissionsService: UserPermissionsService) {
		//@Inject(DOCUMENT) protected document:Document,
		super(componentFactoryResolver, target);
	}


	ngOnChanges(changes: SimpleChanges): void {
		if (changes["disabled"] && !changes["disabled"].isFirstChange()){
			this.handleTooltip();
		} else if (changes["codes"] && !changes["codes"].isFirstChange()){
			this.handleTooltip();
		}
	}

	public ngOnInit(): void {
		if (this.subscribeToHotKeyEvent) {
			this.hotKeysService.loadHotKeys()
				.pipe(untilDestroyed(this))
				.subscribe(() => {
					this.hotKeysPressSubscription?.unsubscribe();
					this.hotKeysPressSubscription = this.hotKeysService.getObservable(this.codes, this.preventHotKeyEventDefault)
						.pipe(untilDestroyed(this))
						.subscribe((event) => {
							if (!this.disabled && this.userPermissionsService.getPermissions(this.permission) === AuthLevel.Full) {
								this.hotKeysPress.emit(event);
							}
						});
				});
		}
	}

	ngAfterViewInit(): void {
		this.handleTooltip();
	}

	ngOnDestroy(): void {
		this.hotKeysPressSubscription?.unsubscribe();
		this.hotKeysSubscription?.unsubscribe();
	}

	private handleTooltip(){
		if (this.disableTooltip) {
			return;
		}

		this.hotKeysSubscription?.unsubscribe();
		this.hotKeysSubscription=this.hotKeysService.loadHotKeys()
			.pipe(untilDestroyed(this))
			.subscribe(() => {
				if (!this.origTitleText && !this.disabled) {
					if (!this.titleText){
						this.origTitleText=this.target.element.nativeElement?.title;
					}else{
						this.origTitleText=this.titleText;
					}
				}
				if (this.disabled){
					this.titleText=this.origTitleText;
					this.titleTextSecondary="";
				}else {
					if (!this.titleText){
						this.titleText=this.target.element.nativeElement?.title;
					}
					if (this.titleText) {
						this.titleTextSecondary = this.getHotKeyTooltipText();
					} else {
						this.titleText = this.getHotKeyTooltipText();
					}
				}
				super.insertTooltipComponent(true);
			});
	}
	private getHotKeyTooltipText() {
		if (!this.codes) {
			return '';
		}

		let codesArray = this.codes instanceof Array ? this.codes : [this.codes];
		let text =  codesArray.map(code => this.getHotKeyString(code)).join(',')  ;
		return text;
	}

	private getHotKeyString(hotKeyCode: string): string{
		let hotKey : IHotKey = this.hotKeysService.getHotKey(hotKeyCode);
		if (hotKey && hotKey.hotKey) {
			return this.hotKeyUtils.toString(hotKey.hotKey);
		}
		return '';
	}
}
